<template>
  <div :class="['rereadUpImg']">
    <div v-show="fileList.length" class="uploadImgBox">
      <div class="fileListBox">
        <van-uploader
          id="vanUploader"
          :max-count="3"
          :after-read="afterRead"
          v-model="fileList"
          :before-delete="deleteFn"
        >
          <img @click="handleUpload" class="takePhoto" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiAssistantZz/addImage.png" />
        </van-uploader>
      </div>
    </div>
    <div :class="{upload_box:true,isAndroid:isAndroid}">
      <img @click="handleUpload" class="takePhoto" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiAssistantZz/takePhoto.png" />
    </div>
  </div>
</template>

<script>
import Compressor from 'compressorjs';
import { ADMIN_URL,isOhos } from '@/utils/common';
import axios from 'axios';
import {judgmentPlatform} from "@/utils/tools";

export default {
  components: {},
  props: ['fileList'],
  data() {
    return {
      isEmpty: true,
      isShowPreview: false, // 是否开启预览
      isShowExamplePreview: false,
      defaultExampleList: [
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/bilibiliShipments/%E7%BC%96%E7%BB%84%2018%402x.png`,
      ],
      loading: false,
      isAndroid:judgmentPlatform() === 'android'
    };
  },
  methods: {
    handleUpload(){
      if (this.fileList?.length >= 3) {
        this.$toast('图片最多上传3张');
      }
      document.getElementById('vanUploader').click()
    },
    deleteFn(e){
      this.fileList = this.fileList?.filter(item=> item.url !== e.url)
      this.$emit('getListFile', this.fileList);
    },
    arouse() {
      if (this.$root.$data.isApp) {
        window.uploaderFiles = (value) => {
          const data = isOhos ? value : JSON.parse(value);
          console.log(value)
          console.log(data)
          if (data.success !== 1) {
            this.$toast.fail('上传失败');
          } else {
            this.isEmpty = false;
            this.fileList = [];
            let tempImg = data.images[0]+'?x-oss-process=image/quality,q_60'
            this.fileList.push(tempImg);
            console.log(tempImg)
            console.log(this.fileList)
            this.$emit('getListFile', this.fileList);
          }
        };
        this.$sendToApp('arouseImagePicker', { pickNum: 1 });
      }
    },
    previewImage(index) {
      // 图片预览
      this.isShowPreview = true;
    },

    afterRead(file) {
      let that= this;
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const path = `${ADMIN_URL}/ref/v1/oss/file?type=image`;
      const formData = new FormData();
      let quality = 1
      if (file.file.size < 1000 * 1000) { //小于1M
        quality = 0.8
      } else if (file.file.size < 5000 * 1000) { //小于5M
        quality = 0.5
      } else if (file.file.size < 10000 * 1000) { //小于10M
        quality = 0.3
      } else { //大于10M
        quality = 0.1
      }
      new Compressor(file.file, {
        quality: quality,
        success(result) {
          let newFile = new File([result], result.name, { type: result.type })
          formData.append('file', newFile);
          axios({
            url: path,
            method: 'POST',
            data: formData,
            processData: false, // 告诉axios不要去处理发送的数据(重要参数)
            contentType: false, // 告诉axios不要去设置Content-Type请求头
          })
            .then((res) => {
              if (res.data.code === 0) {
                const arr = [...that.fileList,{url:res.data.data,isImage:true,status: 'done'}]
                that.$emit('getListFile', arr);
                that.isEmpty = false;
              } else {
                that.$toast.fail('上传失败');
              }
              that.$toast.clear();
            })
        },
      });
    },

    goSubmit() {
      this.$emit('cardSubmit');
    },
  },
};
</script>

<style scoped lang="scss">
.rereadUpImg {
  width: 100%;
  .uploadImgBox {
    width: 100%;
    height: 282px;
    overflow: auto;
    box-sizing: border-box;
    padding: 0 36.23px;
    padding-top: 36px;
    background: #ffffff;
    .cameraBox {
      position: relative;
      width: 678px;
      height: 80px;
    }
    .listImg {
      display: block !important;
      ::v-deep .van-image__img {
        display: block;
        max-width: 100%;
        height: 100%;
        overflow: auto;
        margin: 0 auto;
        border-radius: 18px;
      }
    }
    ::v-deep .van-uploader__input {
      position: fixed;
      //top: auto;
      bottom: 32px;
      height: 45px;
      opacity: 0;
    }
    ::v-deep .closeIcon {
      display: none;
    }
  }
  .fixedbottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 167px;
    background: #ffffff;
    border-radius: 22px 22px 2px 2px;
    padding-top: 22px;
    box-shadow: 0px -4px 14px 0px rgba(0, 0, 0, 0.05);
    .tmallBtn {
      width: 678px;
      height: 80px;
      line-height: 80px;
      background: #ff7f41;
      border-radius: 49px;
      margin: 0 auto;
      color: #fff;
      font-size: 32px;
      text-align: center;
    }
  }
  .editFixedbottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 167px;
    background: #ffffff;
    border-radius: 22px 22px 2px 2px;
    padding-top: 22px;
    display: flex;
    box-shadow: 0px -4px 14px 0px rgba(0, 0, 0, 0.05);
    .editBtn {
      width: 330px;
      height: 80px;
      border-radius: 45px;
      border: 2px solid #ff7f41;
      line-height: 80px;
      margin: 0 auto;
      color: #ff7f41;
      font-size: 32px;
      text-align: center;
    }

    .tmallBtn {
      width: 330px;
      height: 80px;
      background: #ff7f41;
      border-radius: 45px;
      line-height: 80px;
      margin: 0 auto;
      color: #fff;
      font-size: 32px;
      text-align: center;
    }
  }
}
.phoHeight {
  height: calc(100vh - 167px - 100px);
  ::v-deep .van-uploader__input {
    width: 50%;
  }
}
.takePhoto{
  width: 54px;
  height: 54px;
}
.upload_box{
  position: absolute;
  bottom: -80px;
  left: 62px;
}
.upload_box.isAndroid{
  bottom: -87px;
}
.fileListBox{
  width: 100%;
  height: 210px;
  overflow: hidden;
}
::v-deep .van-uploader__preview{
  width: 31%;
  aspect-ratio: 1 / 1;
  margin-bottom: 0;
  .van-uploader__preview-image{
    width: 100%;
    height: 100%;
  }
}
::v-deep .van-uploader__input-wrapper{
  width: 31%;
  aspect-ratio: 1 / 1;
  margin-bottom: 0;
  background: #F1F1F3;
  border-radius: 9px;
  text-align: center;
  align-content: center;
  img{

  }
}
::v-deep .van-uploader{
  width: 100%;
}
::v-deep .van-uploader__wrapper{
  overflow:hidden;
  display: flex;
  justify-content: flex-start;
}
::v-deep .van-uploader__wrapper .van-uploader__preview:last-child{
  margin-right: 0;
}
</style>
